module.exports = __webpack_public_path__ + "img/DefaultLogo.18ca6d1e.jpg";